var React = require('react');

function ForfColor (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"a"},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","fill":"#111111","d":"M81.3,13.7H65.2c-3.3,0-4.7,1.3-4.9,3.5l-2.9,30.3H44.1l2.7-28.3\n\t\tc1-10.7,6.3-16.2,16-16.7h29.6C91.4,9.6,87.5,13.7,81.3,13.7z M30.5,47.5l0.8-8.1l1-10.5l1.1-10.6L19.2,28.9h11.2l-1,10.5H5.6\n\t\tc-3.9,0-6-2-5.6-5.9c0.2-2,1-3.3,4.3-5.8L35.6,3.9c1.7-1.1,3.6-1.6,5.6-1.4c2.2,0,5.4,1.4,5.1,4.5l-4,40.5H30.5z M80.9,21.9\n\t\tc-1,7.1-4.6,10.4-10.8,10.5h-9.4l1-10.5H80.9z"})));
}

ForfColor.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 92.4 50","enableBackground":"new 0 0 92.4 50","xmlSpace":"preserve"};

module.exports = ForfColor;

ForfColor.default = ForfColor;
